import { styled, TableCell, Select, alpha } from '@mui/material';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '350px',
  cursor: 'pointer',
  fontSize: '0.85rem',
  borderBottom: `1px solid ${theme.palette.divider}`,
  transition: theme.transitions.create('background-color'),
  '&:hover': {
    background: alpha(theme.palette.primary.main, 0.08),
  },
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  borderRadius: 10,
  fontSize: '0.85rem',
  backgroundColor: theme.palette.background.default,
  '.MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.divider },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: alpha(theme.palette.primary.main, 0.5) },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
  '& .MuiSelect-select': { paddingTop: 9, paddingBottom: 9 },
}));
